export default "__VITE_ASSET__XJ4XqRTe__"